var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04297 13.3501L6.1157 14.4229L12.1157 8.42285L6.1157 2.42285L5.04297 3.49558L9.97021 8.42285L5.04297 13.3501Z",
    fill: "#9095A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightLarge);
export default __webpack_public_path__ + "static/media/chevron-right-large.6cbb14cd34ca20dcb9a0a66993464059.svg";
export { ForwardRef as ReactComponent };